import {
  Flex,
  Grid,
  GridItem,
  Icon,
  Image,
  Progress,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import FileUploadSVG from '../../assets/fileUploadSVG.svg';
import { RiDeleteBinLine } from 'react-icons/ri';
import { MdRefresh } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';

function formatFileSize(bytes, decimalPoint = 2) {
  if (bytes === 0) return '0 Bytes';
  var k = 1024,
    dm = decimalPoint || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const UploadedFileCard = ({
  fileObj,
  progress,
  handleDelete,
  handleAction,
}) => {
  return (
    <Grid
      templateAreas={`"icon main1 action"
                  "icon main2 main2"`}
      gridTemplateRows={'1.5fr 0.5fr'}
      gridTemplateColumns={'30px 1fr 30px'}
      h="70px"
      gap="1"
      // color="blackAlpha.700"
      // color="#1B2559"
      fontWeight="bold"
      width="100%"
      boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
    >
      <GridItem
        area={'main1'}
        display="flex"
        flexDir="column"
        justifyContent="end"
      >
        <Text fontSize="0.8rem">{fileObj?.name?.substring(0, 40)}</Text>
        <Text fontSize="0.7rem">{formatFileSize(fileObj?.size)}</Text>
      </GridItem>
      <GridItem area={'main2'}>
        <Flex alignItems="center">
          <Progress
            hasStripe
            size="sm"
            value={progress}
            width={{ base: '95%', md: '90%' }}
          />
          <Text
            fontSize="0.8rem"
            width={{ base: '0%', md: '13%' }}
            display={{ base: 'none', md: 'block' }}
            ml="5px"
          >
            {progress}%
          </Text>
        </Flex>
      </GridItem>

      <GridItem
        display="flex"
        alignItems="center"
        justifyContent="center"
        area={'icon'}
      >
        <Image src={FileUploadSVG} height="32px" width="32px" />
      </GridItem>
      <GridItem
        display="flex"
        alignItems="center"
        justifyContent="center"
        area={'action'}
      >
        {/* Uploading */}
        {fileObj?.error === undefined && (
          <Icon
            as={RxCross2}
            height="18px"
            width="18px"
            title="Cancel Upload"
            style={{ cursor: 'pointer' }}
            onClick={() => handleAction(fileObj?.id, 'cancel')}
          />
        )}

        {/* Error Occured */}
        {fileObj?.error && (
          <Icon
            as={MdRefresh}
            height="18px"
            width="18px"
            title="Retry Upload"
            style={{ cursor: 'pointer', color: 'red' }}
            onClick={() => handleAction(fileObj?.id, 'retry')}
          />
        )}

        {/* Uploaded Successfully*/}
        {fileObj?.error === false && (
          <Icon
            as={RiDeleteBinLine}
            height="18px"
            width="18px"
            title="Delete"
            style={{ cursor: 'pointer' }}
            onClick={() => handleAction(fileObj?.id, 'delete')}
          />
        )}
      </GridItem>
    </Grid>
  );
};

export default UploadedFileCard;
